import {
  EMPLOYEE_GROUP_PAGE,
  GET_EMPLOYEE_GROUP,
  FETCH_EMPLOYEE_GROUP,
  UPDATE_EMPLOYEE_GROUP,
  DELETE_EMPLOYEE_GROUP,
  PENDING_EMPLOYEE_GROUP,
  CLEAR_EMPLOYEE_GROUP,
} from "../constants/actions";

const initialState = {
  employee_groups: [],
  employee_group: {},
  pending: false,
  page: {},
};

export default function EmployeeGroup(state = initialState, action) {
  switch (action.type) {
    case EMPLOYEE_GROUP_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case GET_EMPLOYEE_GROUP:
      return {
        ...state,
        employee_groups: action.payload?.results || action.payload || [],
      };

    case FETCH_EMPLOYEE_GROUP:
      return {
        ...state,
        employee_group: action.payload,
      };

    case UPDATE_EMPLOYEE_GROUP:
      // Check if the employee group already exists in the list
      const existingIndex = state.employee_groups.findIndex(
        (group) => group.id === action.payload.id
      );

      if (existingIndex !== -1) {
        // Update existing employee group
        const updatedGroups = [...state.employee_groups];
        updatedGroups[existingIndex] = action.payload;
        return {
          ...state,
          employee_groups: updatedGroups,
          employee_group: action.payload,
        };
      } else {
        // Add new employee group
        return {
          ...state,
          employee_groups: [...state.employee_groups, action.payload],
          employee_group: action.payload,
        };
      }

    case DELETE_EMPLOYEE_GROUP:
      return {
        ...state,
        employee_groups: state.employee_groups.filter(
          (group) => group.id !== action.payload.id
        ),
        employee_group: 
          state.employee_group.id === action.payload.id
            ? {}
            : state.employee_group,
      };

    case PENDING_EMPLOYEE_GROUP:
      return {
        ...state,
        pending: action.payload,
      };

    case CLEAR_EMPLOYEE_GROUP:
      return {
        ...state,
        employee_groups: [],
        employee_group: {},
        pending: false,
        page: {},
      };

    default:
      return state;
  }
}